import React from 'react';
import PropTypes from 'prop-types';
import Img from 'ui/imageWithFallback';
import {Button, SubTitle, FormationTeaser, DateBlock, Title} from './styles';
import {withRouter} from 'react-router';

const FormationItem = ({history, date, image, sous_titre, titre, buttonId}) => (
  <FormationTeaser>
    <DateBlock>{date}</DateBlock>
    <Img src={image} />
    <div>
      <Title
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: titre,
        }}
      />
      <SubTitle
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sous_titre,
        }}
      />
    </div>
    <Button color="white" onClick={() => history.push(`/formations/${buttonId}`)}>
      En savoir plus
    </Button>
  </FormationTeaser>
);

FormationItem.propTypes = {
  date: PropTypes.string,
  image: PropTypes.string,
  titre: PropTypes.string,
  sous_titre: PropTypes.string,
  buttonId: PropTypes.number,
  history: PropTypes.object.isRequired,
};

export default FormationItem |> withRouter;
